/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */
 
export const LOGIN = "@auth/LOGIN";
export const LIVE_INITIALIZED = "@auth/LIVE_INITIALIZED";
export const LOGOUT = "@auth/LOGOUT";
export const REGISTER = "@auth/REGISTER";
